import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { PlaceCategoryCreateInput, PlaceCategoryDto, PlaceCategoryUpdateInput } from '@upme/contracts';
import { api } from '../../../app/api-client';

export const placeCategoriesKey = ['admin', 'place-categories'] as const;

export const listPlaceCategoriesOptions = () =>
  queryOptions({
    queryKey: [...placeCategoriesKey],
    queryFn: () => api.get('admin/place-categories').json<PlaceCategoryDto[]>(),
    staleTime: 30_000,
  });

export const placeCategoryByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...placeCategoriesKey, id],
    queryFn: () => api.get(`admin/place-categories/${id}`).json<PlaceCategoryDto>(),
  });

export function useAdminPlaceCategories() {
  return useQuery(listPlaceCategoriesOptions());
}

export function useCreatePlaceCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PlaceCategoryCreateInput) =>
      api.post('admin/place-categories', { json: input }).json<PlaceCategoryDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...placeCategoriesKey] }),
  });
}

export function useUpdatePlaceCategory(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PlaceCategoryUpdateInput) =>
      api.patch(`admin/place-categories/${id}`, { json: input }).json<PlaceCategoryDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...placeCategoriesKey] }),
  });
}

export function useDeletePlaceCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`admin/place-categories/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...placeCategoriesKey] }),
  });
}
